import React from 'react';
import { ProductPlansSection } from 'shared-types';

interface ProductPlansSectionEditorProps {
    section: ProductPlansSection;
    onChange: (newSection: ProductPlansSection) => void;
}

const ProductPlansSectionEditor: React.FC<ProductPlansSectionEditorProps> = ({ section, onChange }) => {
    
    const handleContentChange = (field: keyof ProductPlansSection['content'], value: string) => {
        onChange({ ...section, content: { ...section.content, [field]: value } });
    };

    return (
        <div className="space-y-4">
             <div>
                <label className="text-sm font-medium text-slate-600 dark:text-slate-400">Section Title</label>
                <input 
                    type="text" 
                    value={section.content.title} 
                    onChange={e => handleContentChange('title', e.target.value)}
                    className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" 
                />
            </div>
            <p className="text-xs text-slate-500 dark:text-slate-400 italic">
                Note: The product plans displayed in this section are managed globally. You can edit them from the main "Product Plans" section in the site overview.
            </p>
        </div>
    );
};

export default ProductPlansSectionEditor;